/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { mapDependencies } from './dependenciesMap.generated.js';
import { sqrtDependencies } from './dependenciesSqrt.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { varianceDependencies } from './dependenciesVariance.generated.js';
import { createStd } from '../../factoriesAny.js';
export var stdDependencies = {
  mapDependencies,
  sqrtDependencies,
  typedDependencies,
  varianceDependencies,
  createStd
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesStd.generated.js
// module id = 1483
// module chunks = 2